import { Controller } from "@hotwired/stimulus";

// Guards against accidental price changes: keeps Save disabled until the
// input holds a positive amount that differs from the current price.
export default class extends Controller {
  static targets = ["input", "submit"];
  static values = { current: Number };

  connect() {
    this.validate();
  }

  validate() {
    const amount = parseFloat(this.inputTarget.value);
    const valid = Number.isFinite(amount) && amount > 0 && amount !== this.currentValue;
    this.submitTarget.disabled = !valid;
  }
}
